var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeChallengeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1678",
    "data-name": "Group 1678",
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.37,
    height: 59.37,
    viewBox: "0 0 59.37 59.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_83",
    "data-name": "Ellipse 83",
    cx: 29.685,
    cy: 29.685,
    rx: 29.685,
    ry: 29.685,
    transform: "translate(0)",
    fill: "#fff",
    opacity: 0.106
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "shield-check",
    d: "M23.212,2.738,15.2.065a1.279,1.279,0,0,0-.809,0L6.374,2.738A6.387,6.387,0,0,0,2,8.805v6.546C2,25.027,13.769,30.37,14.273,30.593a1.279,1.279,0,0,0,1.039,0c.5-.223,12.273-5.566,12.273-15.241V8.805a6.387,6.387,0,0,0-4.374-6.068Zm-2.383,9.693L15.363,17.9a2.4,2.4,0,0,1-1.708.707h-.042a2.4,2.4,0,0,1-1.721-.768l-2.95-3.07A1.279,1.279,0,1,1,10.786,13l2.871,2.994,5.358-5.373a1.279,1.279,0,1,1,1.809,1.809Z",
    transform: "translate(14.896 14.333)",
    fill: "#fff",
    opacity: 0.582
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeChallengeIcon);
export default __webpack_public_path__ + "static/media/FreeChallengeIcon.1d6351a573cb5f484fd1ada01481d4e7.svg";
export { ForwardRef as ReactComponent };